<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <!-- <CCardHeader>
            <div class="note">
              <strong>Ghi chú:</strong>
              <div class="group-content-note">
                <div>Dấu <span class='required'>*</span> là bắt buộc phải điền</div>
                <div>Tài khoản tối thiểu 4, tối đa 100 kí tự bao gồm chữ thường và số</div>
                <div>Mật khẩu tối thiểu 8, tối đa 128 kí tự bao gồm chữ hoa, chữ thường, số và kí tự đặc biệt là 1 trong
                  số kí tự này @$!%*?&
                </div>
                <div>Số điện thoại gồm 10 kí tự và đúng định số điện thoại nước Việt Nam không bao gồm SĐT cố định. Ví
                  dụ: 033*****00 hoặc
                  8433*****00
                </div>
                <div>Email phải đúng định dạng. Ví dụ: demo@com.vn</div>
              </div>
            </div>
          </CCardHeader> -->
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                  <CRow>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="userNameInput.options" :data="userNameInput.data" />
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="passwordInput.options" :data="passwordInput.data" />
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6" v-if="!$hasAuthor('ROLE_CONSTRUCTION')">
                      <BaseSelect :options="rolesSelect.options" :data="rolesSelect.data" ref="rolesSelect"></BaseSelect>
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6" v-if="$hasAuthor('ROLE_SUPER_ADMIN')">
                      <BaseSelect :options="orgSelect.options" :data="orgSelect.data" ref="orgSelect"></BaseSelect>
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="fullNameInput.options" :data="fullNameInput.data" />
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="phoneInput.options" :data="phoneInput.data" />
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="emailInput.options" :data="emailInput.data" />
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="addressInput.options" :data="addressInput.data" />
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
              <div slot="footer" class="footer-form mt-4">
                <CButton color="secondary" class="btn-action-primary  mr-2" @click="$router.go(-1)"><i class="fa fa-reply"></i>
                  Hủy bỏ
                </CButton>
                <CButton color="primary" class="btn-action-primary" @click="submitData()">
                  <i class="fa fa-save"></i> Lưu lại
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import { Authorities } from "../../constant";

export default {
  name: "UserAdd",
  components: { BaseSelect, BaseInput, BaseLoading },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: { value: false },
      /* Username */
      userNameInput: {
        options: {
          label: "Tên đăng nhập <span class='required'>*</span>",
          placeholder: "Tên đăng nhập",
          type: "text",
          // append: 'N/A'
        },
        data: {
          name: "username",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.userNameInput.data.model;
              // let username_regex = /^([a-zA-Z0-9!%&@#$^*_]){6,}$/;
              let username_regex = /^([a-zA-Z0-9_]){6,100}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên đăng nhập không được để trống";
              } else if (username_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Tên đăng nhập sai định dạng, tối thiểu 6 kí tự";
              } else if (username_regex.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      /* Password */
      passwordInput: {
        options: {
          label: "Mật khẩu <span class='required'>*</span>",
          placeholder: "Mật khẩu",
          type: "password"
        },
        data: {
          name: "password",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.passwordInput.data.model;
              let password_regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,128}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mật khẩu không được để trống";
              } else if (password_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Mật khẩu sai định dạng";
              } else if (password_regex.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      /* Role */
      rolesSelect: {
        options: {
          label: "Quyền tài khoản <span class='required'>*</span>",
          selectAllText: "Chọn quyền tài khoản",
          filter: false,
          'keyField': 'value',
          'valueField': 'text',
        },
        data: {
          model: "",
          name: 'role',
          source: {
            url: "/role/listRole",
            response: function (dataResponse) {
              return dataResponse.data;
            }
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.rolesSelect.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Nhóm người dùng không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          },
        }
      },
      // Organization 
      orgSelect: {
        options: {
          filter: true,
          label: "Đơn vị <span class='required'>*</span>",
          selectAllText: "Chọn đơn vị",
          'keyField': 'value',
          'valueField': 'text',
        },
        data: {
          name: "orgId",
          items: [],
          model: null,
          source: {
            url: '/organization/lstOrg',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.orgSelect.data.items = dataResponse.data;
            }
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.orgSelect.data.model;
              if (value === "" && that.rolesSelect.data.model != Authorities.ROLE_SUPER_ADMIN) {
                this.isValid = false;
                this.errorMessage = "Đơn vị không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          },
        }
      },
      /* Phone */
      phoneInput: {
        options: {
          label: "Số điện thoại <span class='required'>*</span>",
          placeholder: "Số điện thoại",
          type: "number"
        },
        data: {
          name: "phone",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.phoneInput.data.model;
              let phone_regex = /^(0[3|5|7|8|9])+([0-9]{8})$/
              let phone_regex2 = /^(84[3|5|7|8|9])+([0-9]{8})$/
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Số điện thoại không được để trống";
              } else if (phone_regex.test(value) == false && phone_regex2.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Số điện thoại sai định dạng";
              } else if (phone_regex.test(value) == true || phone_regex2.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      /* Address */
      addressInput: {
        options: {
          label: "Địa chỉ <span class='required'>*</span>",
          placeholder: "Địa chỉ",
        },
        data: {
          name: "address",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.addressInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Địa chỉ không được để trống";
              } else if (value.length > 128) {
                this.isValid = false;
                this.errorMessage = "Địa chỉ không được quá 128 kí tự";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      /* Email */
      emailInput: {
        options: {
          label: "Email <span class='required'>*</span>",
          placeholder: "Email",
        },
        data: {
          name: "email",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.emailInput.data.model;
              let email_regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Email không được để trống";
              } else if (email_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Email không đúng định dạng";
              } else if (email_regex.test(value) == true) {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      /* FullName */
      fullNameInput: {
        options: {
          label: "Họ Tên <span class='required'>*</span>",
          placeholder: "Họ và tên",
        },
        data: {
          name: "fullName",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.fullNameInput.data.model;
              let fullname_regex = /^[a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀẾỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪếễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựýỳỵỷỹ ]+$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Họ và tên không được để trống";
              } else if (fullname_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Họ và tên không đúng định dạng";
              } else if (fullname_regex.test(value) == true) {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
    }
  },
  methods: {
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.userNameInput.data.validator.valid();
      isValid &= this.passwordInput.data.validator.valid();
      isValid &= this.phoneInput.data.validator.valid();
      isValid &= this.rolesSelect.data.validator.valid();
      isValid &= this.orgSelect.data.validator.valid();
      isValid &= this.emailInput.data.validator.valid();
      isValid &= this.addressInput.data.validator.valid();
      isValid &= this.fullNameInput.data.validator.valid();
      if (!isValid) {
        return;
      }
      let dataRequest = {
        username: `${this.userNameInput.data.model}`,
        password: this.passwordInput.data.model,
        phone: this.phoneInput.data.model,
        email: this.emailInput.data.model,
        address: this.addressInput.data.model,
        role: this.rolesSelect.data.model,
        orgId: this.orgSelect.data.model,
        fullName: this.fullNameInput.data.model,
      }
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/addUser",
        dataSubmit: function () {
          return dataRequest;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Tạo mới tài khoản thành công"
            });
            that.$router.go(-1);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  watch: {
    'rolesSelect.data.model': function (value) {
      if (value == Authorities.ROLE_SUPER_ADMIN) {
        this.orgSelect.data.model = '';
      } else {
        this.orgSelect.data.model
      }
    }
  }
};
</script>
